import React, { useEffect, useState } from "react";
import Heading from "./Heading";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

interface ITableHeading {
  isDynamic?: any;
  setEnrollmentHeading?: any;
  titlesLength?: any;
  heading: string;
  title?: string;
  setEnrollmentTitleIndex?: any;
}

const EnrollmentTableHeading = ({
  setEnrollmentHeading,
  titlesLength,
  heading,
  title,
  setEnrollmentTitleIndex,
}: ITableHeading) => {
  const [activeChild, setActiveChild] = useState(1);

  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      <Heading heading={heading} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IoIosArrowUp
          onClick={() => {
            setActiveChild((a: any) => (a + 1 > titlesLength ? 0 : a + 1));
            setEnrollmentHeading(title);
            setEnrollmentTitleIndex(activeChild);
          }}
        />
        <IoIosArrowDown
          onClick={() => {
            setActiveChild((a) => (a - 1 < 0 ? titlesLength : a - 1));
            setEnrollmentHeading(title);
            setEnrollmentTitleIndex(activeChild);
          }}
        />
      </div>
    </div>
  );
};

export default EnrollmentTableHeading;
